import {Component} from "@angular/core";

@Component({
  templateUrl: "./user-stats.template.pug",
})
export class UserStatsComponent {
  constructor() {}
}
